import React from 'react';
import { i18n } from "../../lang/i18n"

interface Props {
    style?: any
}

export default function ButtonWhatsApp(props: Props) {
    return <a href="https://api.whatsapp.com/send?phone=34983314659" style={props.style}
    >{i18n._BTNs.WhatsApp} <i className=" fab fa-whatsapp fa-fw"> </i></a>
}